import axios from 'axios';

export async function getLatLngFromAddress(address) {
    if (!address) return null;

    try {
        const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
        const encodedAddress = encodeURIComponent(address);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`;

        const response = await axios.get(url);
        const data = response.data;

        if (data.status === 'OK' && data.results.length > 0) {
            const {lat, lng} = data.results[0].geometry.location;
            return {lat, lng};
        } else {
            console.warn('Không tìm thấy tọa độ cho địa chỉ đã cung cấp.');
            return null;
        }
    } catch (error) {
        console.error('Không thể lấy tọa độ cho địa chỉ đã cung cấp.');
        return null;
    }
}
